export default __webpack_public_path__ + "static/1756-192c49803360fb7c056bd3705718fcda.gif";